import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

// Connects to data-controller="invoices"
var _default = /*#__PURE__*/function (_Controller) {
  function _default() {
    _classCallCheck(this, _default);
    return _callSuper(this, _default, arguments);
  }
  _inherits(_default, _Controller);
  return _createClass(_default, [{
    key: "connect",
    value: function connect() {
      this.initializeTomSelects();
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      // Clean up TomSelect instances
      this.companySelectTargets.forEach(function (select) {
        if (select.tomselect) {
          select.tomselect.destroy();
        }
      });
      this.monthSelectTargets.forEach(function (select) {
        if (select.tomselect) {
          select.tomselect.destroy();
        }
      });
    }
  }, {
    key: "initializeTomSelects",
    value: function initializeTomSelects() {
      // Initialize company selects
      this.companySelectTargets.forEach(function (element) {
        if (!element.tomselect) {
          var tomselect = new TomSelect(element, {
            placeholder: 'Company Name',
            allowEmptyOption: true
          });
          element.tomselect = tomselect;
        }
      });

      // Initialize invoice month selects
      this.monthSelectTargets.forEach(function (element) {
        if (!element.tomselect) {
          var tomselect = new TomSelect(element, {
            placeholder: 'Month Year',
            allowEmptyOption: true
          });
          element.tomselect = tomselect;
        }
      });
    }

    // Action to handle row clicks
  }, {
    key: "openInvoice",
    value: function openInvoice(event) {
      // Don't trigger if clicking on elements with data-disable-click
      if (event.target.closest('[data-disable-click]')) {
        return;
      }
      var link = event.currentTarget.dataset.link;
      if (link) {
        window.open(link, '_blank');
      }
    }
  }]);
}(Controller);
_defineProperty(_default, "targets", ['companySelect', 'monthSelect', 'invoiceRow']);
export { _default as default };